import React from "react";
import { string, number, node, object, bool } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";
import { Link } from "@quintype/components";

import "./contributor.m.css";

const Contributor = ({
  name,
  className = "",
  contributorType = 1,
  slug = "javascript:void(0)",
  role = "",
  publisherAttributes,
  authorObj = {},
  showBio = false,
  authorLocation = "",
}) => {
  let publicAuthorValue = "no";
  let showAuthorBio = "no";
  if (authorObj.metadata && authorObj.metadata["Public Author"]) {
    const publicAuthorStatus = authorObj.metadata["Public Author"].split(",");
    publicAuthorValue = publicAuthorStatus[0] ? publicAuthorStatus[0].toLowerCase() : "no";
    showAuthorBio = publicAuthorStatus[1] ? publicAuthorStatus[1].toLowerCase().trim() : "no";
  }
  const publicAuthorRole =
    authorObj["contributor-role"] && authorObj["contributor-role"].name === "Public Author" ? "yes" : "";

  const authorBio = get(authorObj, ["bio"], "");

  const publicAuthor = () => {
    if (publicAuthorValue) {
      return publicAuthorValue;
    } else if (publicAuthorRole) {
      return publicAuthorRole;
    } else return null;
  };
  return (
    <div
      styleName={` base contributor-type-${contributorType}`}
      className={`${className} contributor-type-${contributorType} contributor-type-${publisherAttributes.lang}`}
    >
      {publicAuthor() === "yes" ? (
        <Link
          styleName={`contributor-name public-author ${publisherAttributes.lang === "en" ? "en-contributor-name" : ""}`}
          className="contributor-name"
          href={slug}
        >
          {name}
        </Link>
      ) : (
        <span
          styleName={`contributor-name ${publisherAttributes.lang === "en" ? "en-contributor-name" : ""}`}
          className="contributor-name"
        >
          {name}
        </span>
      )}
      {authorLocation && <span styleName="author-location">{authorLocation}</span>}
      {showBio && showAuthorBio === "bio" && authorBio && (
        <span styleName="author-bio" className="author-bio">
          {authorBio}
        </span>
      )}
      {role && (
        <span className="contributor-role" styleName={publisherAttributes.lang === "en" ? "en-contributor-role" : ""}>
          {role}
        </span>
      )}
    </div>
  );
};

Contributor.propTypes = {
  name: node,
  className: string,
  contributorType: number,
  slug: string,
  role: string,
  publisherAttributes: object,
  authorObj: object,
  showBio: bool,
  authorLocation: string,
};

const mapStateToProps = (state) => ({
  publisherAttributes: get(state, ["qt", "config", "publisher-attributes"], {}),
});

export default connect(mapStateToProps, null)(Contributor);
